/* BNB - Quick add pop-up for the boxed product cards (Oct 2026)       assets/bnb-quick-add.js
   Loaded only on collection pages. Opens when a shopper taps the round trolley button
   (.bnb-card__cart[data-bnb-qa]) on a product card: desktop gets a centred pop-up,
   phones get a sheet that slides up from the bottom. Uses the live product data
   (/products/<handle>.js) and Shopify's standard /cart/add.js, then opens the Upcart
   cart drawer. Product photos are shown exactly as supplied. */
(function () {
  if (window.__bnbQuickAdd) return;
  window.__bnbQuickAdd = true;

  var root, els = {}, state = null, lastFocus = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function build() {
    root = document.createElement('div');
    root.className = 'bnb-qa';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="bnb-qa__backdrop" data-bnb-qa-close></div>' +
      '<div class="bnb-qa__panel" role="dialog" aria-modal="true" aria-labelledby="bnb-qa-title">' +
        '<div class="bnb-qa__grab" aria-hidden="true"></div>' +
        '<button type="button" class="bnb-qa__close" data-bnb-qa-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="bnb-qa__pic"><img alt=""></div>' +
        '<div class="bnb-qa__body">' +
          '<div class="bnb-qa__vendor"></div>' +
          '<div class="bnb-qa__title" id="bnb-qa-title"></div>' +
          '<div class="bnb-qa__price"></div>' +
          '<div class="bnb-qa__options"></div>' +
          '<div class="bnb-qa__buy">' +
            '<div class="bnb-qa__qty">' +
              '<button type="button" data-bnb-qa-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span aria-live="polite">1</span>' +
              '<button type="button" data-bnb-qa-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="bnb-qa__add">Add to cart</button>' +
          '</div>' +
          '<div class="bnb-qa__msg" role="status"></div>' +
          '<a class="bnb-qa__more" href="#">View full details</a>' +
        '</div>' +
        '<div class="bnb-qa__loading" aria-hidden="true"><span></span></div>' +
      '</div>';
    document.body.appendChild(root);
    ['panel', 'pic', 'vendor', 'title', 'price', 'options', 'qty', 'add', 'msg', 'more'].forEach(function (k) {
      els[k] = root.querySelector('.bnb-qa__' + k);
    });
    els.img = els.pic.querySelector('img');
    els.qtyVal = els.qty.querySelector('span');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bnb-qa-close]')) { close(); return; }
      var q = e.target.closest('[data-bnb-qa-qty]');
      if (q && state) {
        state.qty = Math.max(1, Math.min(99, state.qty + parseInt(q.getAttribute('data-bnb-qa-qty'), 10)));
        els.qtyVal.textContent = state.qty;
        return;
      }
      var pill = e.target.closest('.bnb-qa__pill');
      if (pill && state && !pill.disabled) {
        var idx = +pill.getAttribute('data-i');
        state.sel[idx] = pill.getAttribute('data-v');
        // if that combination is sold out, move later options to the first in-stock choice
        var cur = variantFor(state.sel);
        if (!cur || !cur.available) {
          var alt = state.product.variants.find(function (v) {
            return v.available && v.options.every(function (o, j) { return j > idx || o === state.sel[j]; });
          });
          if (alt) state.sel = alt.options.slice();
        }
        render();
      }
    });
    els.add.addEventListener('click', addToCart);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hasAttribute('hidden')) close();
    });

    // swipe down to close on phones
    var startY = null;
    els.panel.addEventListener('touchstart', function (e) {
      if (els.panel.scrollTop <= 0) startY = e.touches[0].clientY;
    }, { passive: true });
    els.panel.addEventListener('touchend', function (e) {
      if (startY !== null && e.changedTouches[0].clientY - startY > 80) close();
      startY = null;
    }, { passive: true });
  }

  function variantFor(sel) {
    return state.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === sel[i]; });
    });
  }
  function valueAvailable(i, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[i] !== value) return false;
      return v.options.every(function (o, j) { return j === i || j > i || o === state.sel[j]; });
    });
  }

  function render() {
    var p = state.product, v = variantFor(state.sel);
    state.variant = v;
    var html = '';
    p.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = typeof opt === 'string' ? [] : opt.values;
      if (!values.length) values = p.variants.map(function (x) { return x.options[i]; }).filter(function (x, k, a) { return a.indexOf(x) === k; });
      if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return;
      html += '<div class="bnb-qa__label">' + esc(name) + '<em>' + esc(state.sel[i]) + '</em></div><div class="bnb-qa__pills">';
      values.forEach(function (val) {
        var on = state.sel[i] === val, ok = valueAvailable(i, val);
        html += '<button type="button" class="bnb-qa__pill' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" data-i="' + i + '" data-v="' + esc(val) + '"' +
          (ok ? '' : ' disabled aria-disabled="true"') + ' aria-pressed="' + on + '">' + esc(val) + '</button>';
      });
      html += '</div>';
    });
    els.options.innerHTML = html;

    var price = v ? v.price : p.price;
    var compare = v && v.compare_at_price > v.price ? v.compare_at_price : 0;
    els.price.innerHTML = money(price) + (compare ? ' <s>' + money(compare) + '</s>' : '');

    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    if (img) {
      if (img.indexOf('//') === 0) img = 'https:' + img;
      if (els.img.getAttribute('src') !== img) els.img.src = img;
      els.img.alt = p.title;
    }

    var canBuy = !!(v && v.available);
    els.add.disabled = !canBuy;
    els.add.textContent = canBuy ? 'Add to cart' : (v ? 'Sold out' : 'Unavailable');
    els.more.href = p.url || ('/products/' + p.handle);
  }

  function firstAvailableSel(p) {
    var v = p.variants.find(function (x) { return x.available; }) || p.variants[0];
    return v.options.slice();
  }

  function open(handle, url, box) {
    if (!root) build();
    lastFocus = document.activeElement;
    root.removeAttribute('hidden');
    root.classList.add('is-loading');
    els.msg.textContent = '';
    document.documentElement.classList.add('bnb-qa-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        // BNB boxes only online (Nov 2026): when the card says this product sells as a box, offer the box only
        if (box) {
          var si = -1;
          p.options.forEach(function (o, i) { if ((typeof o === 'string' ? o : o.name) === 'Size') si = i; });
          var keep = si > -1 ? p.variants.filter(function (v) { return v.options[si] === box; }) : [];
          if (keep.length) {
            p.variants = keep;
            p.options = p.options.map(function (o, i) {
              if (i !== si || typeof o === 'string') return o;
              var c = {}; for (var k in o) c[k] = o[k]; c.values = [box]; return c;
            });
            p.price = Math.min.apply(null, keep.map(function (v) { return v.price; }));
          }
        }
        state = { product: p, sel: firstAvailableSel(p), qty: 1 };
        els.vendor.textContent = p.vendor || '';
        els.title.textContent = p.title;
        els.qtyVal.textContent = '1';
        render();
        root.classList.remove('is-loading');
        els.add.focus({ preventScroll: true });
      })
      .catch(function () { window.location.href = url; });
  }

  function close() {
    if (!root || root.hasAttribute('hidden')) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('bnb-qa-open');
    setTimeout(function () { root.setAttribute('hidden', ''); state = null; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function addToCart() {
    if (!state || !state.variant || !state.variant.available) return;
    els.add.disabled = true;
    els.add.textContent = 'Adding...';
    els.msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variant.id, quantity: state.qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        close();
        try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
        setTimeout(function () {
          try {
            if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
          } catch (e) {}
          window.location.href = '/cart';
        }, 250);
      })
      .catch(function (err) {
        els.msg.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.';
        els.add.disabled = false;
        els.add.textContent = 'Add to cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bnb-card__cart[data-bnb-qa]');
    if (!btn) return;
    e.preventDefault();
    open(btn.getAttribute('data-bnb-qa'), btn.href, btn.getAttribute('data-bnb-qa-box'));
  });
})();
